import get from 'lodash/get';
import metricsAuthStates from '../constants/auth/metricsAuthStates';
import {
  CLEAR_METRICS_AUTHORIZATION,
  GET_METRICS_AUTHORIZATION,
} from '../actions/metrics';
import { LOGOUT, UNAUTHENTICATE } from '../actions/auth';
import { fulfilled, rejected } from './utils/asyncActionNameSuffixes';
import createMappedReducer from './utils/createMappedReducer';

const initialState = {
  metricsUrl: '',
  metricsAuthState: metricsAuthStates.unauthorized,
};

function setMetricsAuthorizationStatus(state, action) {
  const { authorizedMetricsUser, metricsUrl } = get(action, 'payload.data', {});

  if (authorizedMetricsUser) {
    return {
      metricsUrl,
      metricsAuthState: metricsAuthStates.authorized,
    };
  }
  return initialState;
}

function setMetricsUnauthorizedStatus() {
  return initialState;
}

function clearMetricsAuthorization() {
  return initialState;
}

function unauthFulfilled() {
  return initialState;
}

export const metrics = createMappedReducer(initialState, {
  [fulfilled(GET_METRICS_AUTHORIZATION)]: setMetricsAuthorizationStatus,
  [rejected(GET_METRICS_AUTHORIZATION)]: setMetricsUnauthorizedStatus,
  [fulfilled(LOGOUT)]: unauthFulfilled,
  [UNAUTHENTICATE]: unauthFulfilled,
  [CLEAR_METRICS_AUTHORIZATION]: clearMetricsAuthorization,
});
